<template>
    <div class="mt20 ovh min_height" style="word-break: break-all;">
        <el-table :data="agreementList" style="width: 100%"  v-show="showDetail == 0" border>
            <el-table-column prop="contractCode" label="合同编号" min-width="200" align="center">
            </el-table-column>
            <el-table-column prop="parentContractCode" label="原合同编号" min-width="200" align="center">
            </el-table-column>
            <el-table-column prop="contractName" label="合同名称" min-width="200" align="center">
            </el-table-column>
            <!--<el-table-column label="主营品类" align="center" min-width="300">-->
                <!--<template scope="scope">-->
                    <!--<p v-for="category in scope.row.categoryLevels">{{category.grandName}}-{{category.parentName}}-{{category.childrenName}}</p>-->
                <!--</template>-->
            <!--</el-table-column>-->
            <el-table-column label="合作状态" align="center" min-width="120">
                <template scope="scope">
                    {{scope.row.status == 1 ? '正常合作' : '终止合作'}}
                </template>
            </el-table-column>
            <el-table-column label="开始时间" align="center"  min-width="120">
                <template scope="scope">
                    <span >{{scope.row.contractStartDate | time}}</span>
                </template>
            </el-table-column>
            <el-table-column label="结束时间" align="center"  min-width="120">
                <template scope="scope">
                    <span >{{scope.row.contractEndDate | time}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="100" align="center" fixed="right">
                <template scope="scope">
                    <el-button @click="detail(scope.row.id)" type="text" size="small">详情</el-button>
                    <el-button @click="renew(scope.row.id)" type="text" size="small" v-if="scope.row.renewStatus == 2 && isSupplier == 1">续签</el-button>
                    <el-button @click="stop(scope.row.id)" type="text" size="small" v-if="hasEditContract == 1 && scope.row.status == 1">终止</el-button>
                    <!--<router-link :to="{path:'brandDetail',query: {brandApplyId:scope.row.brandApplyId}}"  target="_blank">
                        <el-button @click="" type="text" size="small">查看详情</el-button>
                    </router-link>-->
                    <!--<router-link :to="{path:'brandDetail',query: {brandApplyId:scope.row.brandApplyId}}" class="el-button el-button&#45;&#45;text el-button&#45;&#45;small" target="_blank">查看详情</router-link>-->
                </template>
            </el-table-column>
        </el-table>
        <div class="pl10 mt20"  v-show="showDetail == 1">
            <span class="dib">合同基本信息</span><span class="line"></span>
            <div class="mt20">
                <el-form label-width="207px" class="demo-ruleForm">
                    <el-form-item label="供应商合同编号："><span>{{ agreementDetail.contractCode }}</span></el-form-item>
                    <el-form-item label="供应商原合同编号：" v-if="agreementDetail.parentContractId>0"><span>{{ agreementDetail.parentContractCode }}</span></el-form-item>
                    <el-form-item label="供应商编号："><span>{{ agreementDetail.suppliersCode }}</span></el-form-item>
                    <el-form-item label="供应商名称："><span>{{ agreementDetail.suppliersName }}</span></el-form-item>
                    <el-form-item label="合作方式：">
                        <span v-if="agreementDetail.cooperationType == 1" >入仓</span>
                        <span v-if="agreementDetail.cooperationType == 2">入仓（实销实结）</span>
                        <span v-if="agreementDetail.cooperationType == 3">自发货</span>
                    </el-form-item>
                    <el-form-item label="发货时效：" v-if="agreementDetail.cooperationType == 3"><span>{{ agreementDetail.deliveryTime }}小时</span></el-form-item>
                    <el-form-item label="合同开始时间："><span>{{ agreementDetail.contractStartTime }}</span></el-form-item>
                    <el-form-item label="合同结束时间："><span>{{ agreementDetail.contractEndTime }}</span></el-form-item>
                    <span class="dib">合同条款-财务信息</span><span class="second_line"></span>
                    <el-form-item label="结算主体：">
                        <span v-if="agreementDetail.settlementBodyId == 1" >北京果敢时代科技有限公司</span>
                        <span v-if="agreementDetail.settlementBodyId == 2" >MAMA HONG KONG</span>
                        <span v-if="agreementDetail.settlementBodyId == 3" >天津果敢时代国际贸易有限公司</span>
                        <span v-if="agreementDetail.settlementBodyId == 4" >正合奇胜（天津）企业咨询管理有限公司</span>
                        <span v-if="agreementDetail.settlementBodyId == 5" >老师线下打款</span>
                    </el-form-item>
                    <el-form-item label="结算方式：">
                        <span v-if="agreementDetail.settlementType == 1" >直采</span>
                        <span v-if="agreementDetail.settlementType == 2" >预付款</span>
                        <span v-if="agreementDetail.settlementType == 3" >实销实结</span>
                    </el-form-item>
                    <el-form-item label="结算币种：">人民币</el-form-item>
                    <el-form-item v-if="agreementDetail.settlementType != 2 && agreementDetail.settlementPaymentType==0" label="结算账期：">
                        <span>{{ agreementDetail.settlementPaymentDays }}天</span>
                    </el-form-item>
                    <el-form-item v-if="agreementDetail.settlementType != 2 && agreementDetail.settlementPaymentType && agreementDetail.settlementPaymentType>=2" label="结算账期：">
                        <span v-if="agreementDetail.settlementPaymentType==2">按年结算</span>
                        <span v-if="agreementDetail.settlementPaymentType==3">按半年结算</span>
                        <span v-if="agreementDetail.settlementPaymentType==4">按季度结算</span>
                        <span v-if="agreementDetail.settlementPaymentType==5">按月结算</span>
                        <span v-if="agreementDetail.settlementPaymentType==6">按半月结算</span>
                    </el-form-item>
                    <el-form-item v-if="agreementDetail.settlementType == 2 && agreementDetail.settlementPaymentRate && agreementDetail.settlementPaymentRate!='0'" label="结算账期：">
                        <span v-for="(paymentRate,index) in agreementDetail.settlementPaymentRate.split(',')">{{index==0?"":","}}第{{index+1}}期{{ paymentRate }}%</span>
                    </el-form-item>
                    <el-form-item label="保证金："><span>{{ agreementDetail.deposit }}人民币</span></el-form-item>
                    <el-form-item label="货款支付方式：">甲方将货款直接支付到乙方的如下银行账户</el-form-item>
                    <el-form-item label="开户银行："><span>{{ agreementDetail.bankName }}</span></el-form-item>
                    <el-form-item label="银行账号："><span>{{ agreementDetail.accountNumber }}</span></el-form-item>
                    <el-form-item label="银行户名："><span>{{ agreementDetail.accountName }}</span></el-form-item>
                    <el-form-item v-if="agreementDetail.registeredCountry != 1" label="SwiftCode："><span>{{ agreementDetail.swiftCode }}</span></el-form-item>
                    <el-form-item v-if="agreementDetail.registeredCountry == 1" label="省："><span>{{ agreementDetail.province }}</span></el-form-item>
                    <el-form-item v-if="agreementDetail.registeredCountry == 1" label="市："><span>{{ agreementDetail.city }}</span></el-form-item>
                    <!--<el-form-item label="银行地址："><span>{{ agreementDetail.bankAddress }}</span></el-form-item>-->
                    <span class="dib">线上合同信息</span><span class="line"></span>
                    <el-form-item label="合同名称：">
                    <span v-for="(content,index) in agreementDetail.templateContents">
                        <el-button @click="contentDetail(content)" type="text" size="small">&nbsp;{{content.name}}&nbsp;</el-button>
                    </span>
                    </el-form-item>
                    <!-- 保存 -->
                    <div class="w60 auto mt120">
                        <el-button type="primary" @click="reback()">返回合同协议列表</el-button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>

</template>

<script type="text/javascript">
    export default {
        data () {
            return {
                suppliersId:0,
                showDetail: 0,
                isSupplier:0,
                hasEditContract:0,
                agreementDetail: {
                },
                agreementList: []
            };
        },
        methods: {
            contentDetail(val){
                window.open("/suppliers/index2/#/" + val.fileName + "_view?type=1&contentId=" + val.contentId + "&templateId=" + val.templateId);
            },
            initAgreementList(suppliersId){
                var that = this;
                $.get({
                    url: '/suppliers/supplier/agreement/list',
                    data: {
                        suppliersId: suppliersId
                    },
                    success: function(result) {
                        if (!result.code && result.code==0) {
                            that.agreementList=result.data.agreementList;
                            that.hasEditContract = result.data.hasEditContract;
                            that.isSupplier = result.data.isSupplier;
                        } else if(result.code == 10067) {
                            window.location.href = "/suppliers/index";
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },
           stop(id){
               var that = this;
               that.$confirm('此操作将终止合同合作, 是否继续?', '提示', {
                   confirmButtonText: '确定',
                   cancelButtonText: '取消',
                   type: 'warning'
               }).then(() => {
                   $.get({
                       url: '/suppliers/supplier/agreement/stop',
                       data: {
                           agreementId: id
                       },
                       success: function(result) {
                           if (!result.code && result.code==0) {
                               that.initAgreementList(that.suppliersId);
                           } else {
                               that.$message({
                                   showClose: true,
                                   message: result.msg,
                                   type: 'error'
                               });
                           }
                       }
                   })
               }).catch(() => {
                   this.$message({
                       type: 'info',
                       message: '已取消终止'
                   });
               });
           },
           renew(id){
               var that = this;
               this.$confirm('确认要续签合同？', '提示', {
                   confirmButtonText: '确定',
                   cancelButtonText: '取消',
                   type: 'warning'
               }).then(() => {
                   $.ajax({
                       type: "get",
                       url: '/suppliers/agreementApply/contractApply/renew',
                       dataType: "json",
                       data: {
                           contractId: id
                       },
                       success: function(result) {
                           if (!result.code && result.code==0) {
                               setTimeout(function () {
                                   that.$router.push({
                                       path:'/contract_edit?contractId=' + result.data.contractId
                                   })
                               },500);
                           } else {
                               that.$message({
                                   showClose: true,
                                   message: result.msg,
                                   type: 'error'
                               });
                           }
                       }
                   })
               }).catch(() => {
                   this.$message({
                       type: 'info',
                       message: '已取消续签'
                   });
               });
           },
           detail(id){
               var that = this;
               $.get({
                   url: '/suppliers/supplier/agreement/detail',
                   data: {
                       agreementId: id
                   },
                   success: function(result) {
                       if (!result.code && result.code==0) {
                           that.agreementDetail=result.data;
                           that.showDetail = 1;
                           that.$parent.showButton = 0;
                           that.$parent.argeementListShowButton = 0;
                       } else if(result.code == 10067) {
                           window.location.href = "/suppliers/index";
                       } else {
                           that.$message({
                               showClose: true,
                               message: result.msg,
                               type: 'error'
                           });
                       }
                   }
               })
           },
            reback(){
                this.showDetail = 0;
                this.$parent.showButton = 1;
                this.$parent.argeementListShowButton = 1;
            }

        },
        mounted () {
            var suppliersId=this.$route.query.suppliersId;
            this.suppliersId = suppliersId;
            this.initAgreementList(suppliersId);
        }
    }
</script>

<style type="text/css" lang="less" scoped>
    .line {
            display: inline-block;
            margin-left: 3%;
            width: 85%;
            height: 1px;
            border-bottom: 1px dashed #999;
            vertical-align: middle;
        }
        .second_line {
            display: inline-block;
            margin-left: 3%;
            width: 81.8%;
            height: 1px;
            border-bottom: 1px dashed #666;
            vertical-align: middle;
        }
        .word_num {
            display: inline-block;
            margin-bottom: 22px;
            margin-left: 5px;
            color: #666;
            vertical-align: bottom;
        }
        .pic_tip {
            position: absolute;
            top: 100%;
            left: 0;
            padding-top: 4px;
            color: #ff4949;
            font-size: 12px;
            line-height: 1px;
        }
        .pic_skan {
            box-sizing: border-box;
            margin-top: 5px;
            width: 150px;
            height: 150px;
            border: 1px solid #c0ccda;
            border-radius: 6px;
            cursor: pointer;
        }
        .pic_min_skan {
            box-sizing: border-box;
            margin-top: 5px;
            width: 60px;
            height: 60px;
            border: 1px solid #c0ccda;
            border-radius: 6px;
            cursor: pointer;
        }
        .form_color {
            color: rgb(106, 72, 77);
        }
        .el-form-item {
            margin-bottom: 0;
        }
</style>


// WEBPACK FOOTER //
// agreementList.vue?78b6f822